module.exports = __webpack_public_path__ + "img/3_no.09337653.svg";